import {autorun, makeAutoObservable, reaction, runInAction, when} from "mobx";
import {checkRunningGameApi} from "@services/runningGame/api";
import {navigateStore, routes} from "@services/navigateObserver/navigate.store";
import {socket, socketStore} from "@services/socket";
import {
    getValueFromLocalStorage,
    removeValueFromLocalStorage,
    setValueToLocalStorage
} from "@shared/helpers/localstorage.helper";
import {WithDisposers} from "@services/WithDisposers";
import {sessionStore} from "@services/session";
import {WithToggle} from "@shared/hoc/WithToggle";
import {routerStore} from "@services/routerObserver/router.store";

export class RunningGameStore {

    private _disposers = new WithDisposers()

    private _gameId: string | null = getValueFromLocalStorage('gameId') || null

    isRunningGame = false

    isLoading = new WithToggle()

    constructor() {
        makeAutoObservable(this)
    }

    onMount = () => {
        this.startReactions()
    }

    onUnmount = () => {
        this.stopReactions()
    }

    startReactions() {
        this.stopReactions();

        this._disposers.subscribe(
            reaction(
                () => this._gameId,
                (gameId) => {
                    if (gameId) {
                        navigateStore.navigate(routes.game)
                    }
                },
                {fireImmediately: true},
            ),
            reaction(
                () => ({
                    isAuth: sessionStore.isAuth,
                    socketError: socketStore.error,
                    pathname: routerStore.pathname,
                }),
                ({isAuth, socketError}) => {
                    if (isAuth && !socketError) {
                        this.checkRunningGame()
                    }
                },
                {fireImmediately: true},
            )
        );
    }

    stopReactions() {
        this._disposers.unsubscribe()
    }

    get gameId() {
        return this._gameId;
    }

    setGameId = (id: string | null) => {
        runInAction(() => {
            this._gameId = id
        })
        if (id) {
            setValueToLocalStorage('gameId', id)
        }
    }

    clearGameId = () => {
        runInAction(() => {
            this._gameId = null
        })
        removeValueFromLocalStorage('gameId')
    }

    checkRunningGame = async () => {
        try {
            const data = await checkRunningGameApi.checkRunningGame()
            if (data) {
                this.setGameId(data)
                // navigateObserver.navigateObserver(`/game`)
            } else {
                // navigateStore.navigate(routes.home)
            }

        } catch (e) {
            navigateStore.navigate(routes.home)
            console.log(e)
        } finally {
            runInAction(() => {
                this.isLoading.setFalse()
            })
        }
    }

    goToMainPage = () => {
        this.clearGameId()
        navigateStore.navigate(routes.home)
    }
}

export const runningGameStore = new RunningGameStore()